import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.tsx'
import './index.css'

// Register PWA Service Worker with auto-update
const updateSW = registerSW({
  onNeedRefresh() {
    // Show update prompt to user
    if (confirm('Nova versão disponível! Atualizar agora?')) {
      updateSW(true)
    }
  },
  onOfflineReady() {
    console.log('Obrim está pronto para uso offline!')
  },
  onRegisteredSW(swUrl, registration) {
    console.log('Service Worker registrado:', swUrl)
    
    // Check for updates every hour
    if (registration) {
      setInterval(() => {
        registration.update()
      }, 60 * 60 * 1000)
    }
  },
  onRegisterError(error) {
    console.error('Erro ao registrar Service Worker:', error)
  }
})

createRoot(document.getElementById("root")!).render(<App />);
